import React from 'react';
import { Typography } from '@mui/material';
import { SONOS_BLUE } from './sonosUiStyles';

interface PlayingSourceLabelProps {
  label?: string | null;
  variant?: 'compact' | 'expanded';
  sx?: object;
}

const VARIANT_STYLES = {
  compact: {
    color: SONOS_BLUE,
    fontSize: 13,
    lineHeight: 1.2,
  },
  expanded: {
    color: SONOS_BLUE,
    fontSize: 13,
    lineHeight: 1.2,
  },
} as const;

const PlayingSourceLabel: React.FC<PlayingSourceLabelProps> = ({
  label,
  variant = 'compact',
  sx,
}) => {
  if (!label) return null;
  return (
    <Typography sx={{
      ...VARIANT_STYLES[variant],
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      ...sx,
    }}>
      {label}
    </Typography>
  );
};

export default PlayingSourceLabel;
